"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {
        alignItems: 'flex-start'
      },
      label: {}
    }
  );
}, {
  name: 'AgreementField'
});

function AgreementField(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      error = _ref.error,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "error", "onChange", "value"]);
  var classes = useStyles({
    classes: pClasses
  });

  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_FormGroup.default, null, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      color: "primary",
      checked: value,
      onChange: handleChange
    }),
    label: children,
    classes: {
      label: classes.label
    }
  })), error && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, error));
}

process.env.NODE_ENV !== "production" ? AgreementField.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  classes: _propTypes.default.shape({
    label: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
} : void 0;
AgreementField.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  error: undefined,
  onChange: undefined,
  value: undefined
};
var _default = AgreementField;
exports.default = _default;